import { isPlainObject } from './isPlainObject';
import type { BrandPointer } from './types/BrandFile';

// Brand ids are lowercase UUIDs, minted when a brand is published.
export const BRAND_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

// The colours a brand can set.
export const BRAND_COLOR_KEYS = [
  'primary',
  'secondary',
  'background',
  'surface',
  'text',
] as const;

export const isBrandId = (value: unknown): value is string =>
  typeof value === 'string' && BRAND_ID_PATTERN.test(value);

export const isBrandPointer = (value: unknown): value is BrandPointer =>
  isPlainObject(value) &&
  isBrandId(value['id']) &&
  typeof value['url'] === 'string';

/** The Storage path of a protocol's brand copy: its brand file, or JSON
 *  `null` for a protocol without a brand. */
export const protocolBrandPath = (protocolId: string): string =>
  `protocols/${protocolId}/brand.json`;
